export const BONUS_WINDOW_MS = 10 * 60 * 1000;

const BONUS_COUNTDOWN_ANCHOR_KEY = 'bonusCountdownAnchorMs';
const BONUS_COUNTDOWN_LOAD_ID_KEY = 'bonusCountdownLoadId';

type BonusAnchorOptions = {
  resetOnPageLoad?: boolean;
};

const getCurrentPageLoadId = (): string => {
  if (typeof window === 'undefined') return '';

  const loadId = Number(window.performance?.timeOrigin);
  if (Number.isFinite(loadId) && loadId > 0) {
    return String(Math.floor(loadId));
  }

  return String(Date.now());
};

export const getOrCreateBonusAnchorMs = ({
  resetOnPageLoad = false,
}: BonusAnchorOptions = {}): number => {
  if (typeof window === 'undefined') return Date.now();

  const currentLoadId = getCurrentPageLoadId();
  const storedLoadId = window.sessionStorage.getItem(BONUS_COUNTDOWN_LOAD_ID_KEY);

  if (resetOnPageLoad && storedLoadId !== currentLoadId) {
    const now = Date.now();
    window.sessionStorage.setItem(BONUS_COUNTDOWN_ANCHOR_KEY, String(now));
    window.sessionStorage.setItem(BONUS_COUNTDOWN_LOAD_ID_KEY, currentLoadId);
    return now;
  }

  const storedAnchor = window.sessionStorage.getItem(BONUS_COUNTDOWN_ANCHOR_KEY);
  const parsedAnchor = storedAnchor ? Number(storedAnchor) : NaN;

  if (Number.isFinite(parsedAnchor) && parsedAnchor > 0) {
    if (!storedLoadId) {
      window.sessionStorage.setItem(BONUS_COUNTDOWN_LOAD_ID_KEY, currentLoadId);
    }
    return parsedAnchor;
  }

  const now = Date.now();
  window.sessionStorage.setItem(BONUS_COUNTDOWN_ANCHOR_KEY, String(now));
  window.sessionStorage.setItem(BONUS_COUNTDOWN_LOAD_ID_KEY, currentLoadId);
  return now;
};